export default "__VITE_ASSET__tzI36aW___"